import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IConselhoPagedResponse } from "models/response/conselho-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getCategoryColor } from "utils/category-colors";

type ConselhosTableProps = {
    currentItems: PaginationResponse<IConselhoPagedResponse>;
};

export const ConselhosTable: React.FC<ConselhosTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum conselho encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Área</TableCell>
                        <TableCell>Nome do Conselho</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>
                                <Chip label={item.areaName} size="small" style={getCategoryColor(item.areaName)} />
                            </TableCell>
                            <TableCell>{item.nomeConselho}</TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/conselhos/${item.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
